<template>
    <div class="footer">
        <!-- <div class="lang-btns blk1">
            <div :class="{'lang-btn':true, 'active':lang=='mm'}" @click="setLang('mm')">Burmese</div>
            <div :class="{'lang-btn':true, 'active':lang=='cn'}" @click="setLang('cn')">中文版</div>
            <div :class="{'lang-btn':true, 'active':lang=='en'}" @click="setLang('en')">English</div>
        </div> -->
        <div class="txtcenter blk2">
            <p>call center: 106, +959404068882</p>
            <p>copyRight @ 2018-2026</p>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Footer',
  data(){
    return {

    }
  },
  computed: {
    ...mapState(['lang','langMap'])
  },
  methods: {
    ...mapActions(['setLang']),
    switch(lang){

    }
  }

}
</script>

<style lang="scss" scoped>
    .footer{
        color: #9d6214;
        margin-top: rem(54);
    }
    .lang-btns{
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: rem(400);
        height: rem(60);
        margin: 0 auto;
        border-radius: rem(30);
        background-color: rgba(255,255,255,.3);

        .lang-btn{
            padding: rem(4) rem(16);
            border-radius: rem(20);
            &.active{
                background-color: #fff;
                color: #741aad;
            }
        }
    }
    .blk2{
        margin: rem(36) auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue